import { render, staticRenderFns } from "./FilesWrap.vue?vue&type=template&id=b9429efe"
import script from "./FilesWrap.vue?vue&type=script&lang=js"
export * from "./FilesWrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports